import React from 'react';
import Label from '../atoms/Label';
import Select from '../atoms/Select';
import { cn } from '../utils/cn';

/**
 * FormSelect Component - Molecule
 * Combines Label and Select atoms
 * 
 * @param {Object} props
 * @param {string} props.label - Field label
 * @param {string} props.name - Select name
 * @param {string} props.error - Error message
 * @param {string} props.helperText - Helper text
 * @param {boolean} props.required - Required field
 */
const FormSelect = React.forwardRef(
  (
    {
      label,
      name,
      error,
      helperText,
      required = false,
      className = '',
      labelClassName = '',
      ...selectProps
    },
    ref
  ) => {
    return (
      <div className={cn('space-y-2', className)}>
        {label && (
          <Label
            htmlFor={name}
            required={required}
            className={labelClassName}
          >
            {label}
          </Label>
        )}
        <Select
          ref={ref}
          id={name}
          name={name}
          variant={error ? 'error' : 'default'}
          aria-invalid={error ? 'true' : 'false'}
          aria-describedby={
            error || helperText
              ? `${name}-${error ? 'error' : 'helper'}`
              : undefined
          }
          {...selectProps}
        />
        {error && (
          <p
            id={`${name}-error`}
            className="text-sm text-error-600 dark:text-error-400"
            role="alert"
          >
            {error}
          </p>
        )}
        {helperText && !error && (
          <p
            id={`${name}-helper`}
            className="text-sm text-primary-500 dark:text-primary-400"
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

FormSelect.displayName = 'FormSelect';

export default FormSelect;
